module.exports = __webpack_public_path__ + "img/top_image1.1f53028e.png";